import { createAction } from '@reduxjs/toolkit';

import { GET_LOANS } from './actionTypes';

export const getLoans = createAction<{ fileId: string; sellerId: string }>(
  GET_LOANS.BASE,
);
